// src/components/explorers/wildfireExplorer/tabs/ModelsTab.tsx
import React from 'react';
import { WildfireEntity } from '../../../../types/wildfire';
import './ModelsTab.scss';

interface ModelsTabProps {
  wildfire: WildfireEntity;
}

export const ModelsTab: React.FC<ModelsTabProps> = ({ wildfire }) => {
  const data = wildfire.data || wildfire;

  return (
    <div className="wildfire-detail-content">
      {/* Fire Information */}
      <section className="detail-section">
        <h3>🔥 Fire Behavior Modelling</h3>
        <div className="detail-grid">
          <div className="detail-item">
            <label>Fire Number:</label>
            <span>{data.number || wildfire.fire_number}</span>
          </div>
          <div className="detail-item">
            <label>Status:</label>
            <span>{data.wildfireStatus || 'N/A'}</span>
          </div>
          <div className="detail-item">
            <label>Size:</label>
            <span>{data.estimatedSize ? `${data.estimatedSize} Ha` : 'N/A'}</span>
          </div>
          <div className="detail-item">
            <label>Cause:</label>
            <span>{data.cause || 'N/A'}</span>
          </div>
        </div>
      </section>

      {/* Stub Message */}
      <section className="detail-section stub-message-section">
        <div className="stub-icon">🚧</div>
        <h3>Modelling Features Coming Soon</h3>
        <p>Fire behavior modelling functionality will be implemented here.</p>
        <div className="planned-features">
          <h4>Planned Features:</h4>
          <ul>
            <li>Weather data integration</li>
            <li>Fuel type analysis</li>
            <li>Fire spread prediction</li>
            <li>Resource recommendations</li>
            <li>Risk assessment tools</li>
          </ul>
        </div>
      </section>
    </div>
  );
};
